import "../components/Header.css";
import "../Pages/Gallery.css"
import HEADER from '../components/Header.js';
import FOOTER from '../components/Footer.js';
import SLIDER from '../components/Slider/Slider.jsx';

function Gallery() {
  return(

    <div className='gallery-containter'>
      <HEADER></HEADER>
      < div  className="gallery-main-container">

      <p> If you like any of the following, please note the item number and refrence it in your order</p>
      <SLIDER />
      </div>

      <FOOTER></FOOTER>
    </div>
  )
  }
  
  export default Gallery;